module.exports = __webpack_public_path__ + "img/banner_tr.20cbbdce.jpg";